<template>
  <div class="modal-mask" v-show="show" transition="modal" @click="hide">
    <div class="modal-wrapper">
      <div class="modal-container modal-transition-container" @click.stop>
        <div class="modal-header">
          <slot name="header">
          </slot>
        </div>

        <div class="modal-body">
          <slot name="body">
          </slot>
        </div>

        <div class="modal-footer">
          <slot name="footer">
            <button
              class="btn btn-full-width btn-primary modal-default-button"
              @click="ok"
              :disabled="disableOkBtn"
            >
              <template v-if="okBtnText">{{ okBtnText }}</template>
              <template v-else>{{ $t('ok') }} | {{okBtnText}}</template>
            </button>
            <div class="clear"></div>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Generic modal component

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    okBtnText: String,
    disableOkBtn: false,
  },
  mounted: function () {
    window.addEventListener('keyup', this.keypressed)
  },
  beforeDestroy: function () {
    window.removeEventListener('keyup', this.keypressed)
  },
  methods: {
    keypressed: function (event) {
      let esc = 27
      if (event.keyCode === esc) {
        this.hide()
      }
    },
    hide: function () {
      this.$emit('hide')
    },
    ok () {
      this.$emit('ok')
      this.hide()
    }
  }
}
</script>



// WEBPACK FOOTER //
// Modal.vue?37cc0bc4